import firebase from "../../firebase";

export default function({ officeId, personId }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "pagingAdmin",
        funcName: "removePersonFromOffice",
        data: {
            officeId,
            personId
        }
    });
}
